import { ref as w, watchEffect as b, watch as n, toRef as i, onBeforeUnmount as h, unref as r } from "vue";
import { unrefElement as f } from "./design-system.es125.js";
import { bottomStart as y } from "./design-system.es294.js";
import { createPopper as O } from "./design-system.es297.js";
function L(a) {
  const o = w(null), {
    isOpen: c,
    position: u,
    arrow: d,
    offset: v = [0, 0],
    disabled: p,
    trigger: m,
    menu: g
  } = a;
  function l() {
    const e = f(m), t = f(g);
    r(o) || r(p) || !e || !t || (o.value = O(e, t, {
      placement: r(u) || y,
      modifiers: [
        {
          name: "eventListeners",
          options: {
            scroll: !0,
            resize: !0
          }
        },
        {
          name: "offset",
          options: {
            offset: r(d) ? [0, 8] : r(v)
          }
        }
      ]
    }));
  }
  function s() {
    var e;
    (e = o.value) == null || e.destroy(), o.value = null;
  }
  return b(l), n(i(m), (e, t) => {
    t && f(t) !== f(e) && (s(), l());
  }), h(s), n(i(c), (e) => {
    var t;
    e && ((t = o.value) == null || t.update());
  }), n(i(u), (e) => {
    var t;
    (t = o.value) == null || t.setOptions((E) => ({
      ...E,
      placement: e
    }));
  }), n(i(p), (e) => {
    e && s();
  }), {
    popper: o
  };
}
export {
  L as usePopper
};
//# sourceMappingURL=design-system.es119.js.map
